import { AppBarTone } from '../../contexts/HeaderContext';
import { MachineStatus } from '../../types/machines/machine.types';

/** The app bar colour on a machine page. It follows the status pill. */
export function getMachineStatusTone(status: MachineStatus): AppBarTone {
  switch (status) {
    case 'running_with_warning':
    case 'ready_with_warning':
      return 'warning';
    case 'not_ready':
      return 'negative';
    case 'offline':
    case 'unknown':
      return 'neutral';
    default:
      return 'positive';
  }
}
